<template>
  <div class="container_minat">
    <div class="left_">
      <v-card flat class="form_card pa-5">
        <h3 class="text-center mb-5" style="color: ##3c033d">
          Isi Data Dirimu dan Langsung Dapatkan Kode Voucher Tesnya
        </h3>
        <!-- <form ></form> -->
        <div>
          <div class="flexy mb-5">
            <input
              type="text"
              v-model="form.nama"
              :disabled="loading"
              placeholder="Nama"
              class="input_minat"
            />
            <p class="small_txt red--text mb-0">{{ err.nama }}</p>
          </div>
          <div class="flexy mb-5">
            <input
              type="text"
              v-model="form.email"
              :disabled="loading"
              placeholder="Email"
              class="input_minat"
            />
            <p class="small_txt red--text mb-0">{{ err.email }}</p>
          </div>
          <div class="flexy mb-5">
            <input
              type="text"
              placeholder="No. Handphone"
              v-model="form.no_hp"
              :disabled="loading"
              class="input_minat"
            />
            <p class="small_txt red--text mb-0">{{ err.no_hp }}</p>
          </div>
          <div class="flexy mb-5">
            <input
              type="text"
              placeholder="Nama Sekolah"
              :disabled="loading"
              v-model="form.nama_sekolah"
              class="input_minat"
            />
            <p class="small_txt red--text mb-0">{{ err.nama_sekolah }}</p>
          </div>
          <v-btn
            v-if="!loading"
            class="text-capitalize font-weight-bold rounded-lg"
            dark
            block
            color="#3c033d"
            @click="postData"
            >Submit</v-btn
          >
          <v-btn
            v-else
            class="text-capitalize font-weight-bold rounded-lg"
            dark
            block
            color="#3c033d"
            ><v-progress-circular
              indeterminate
              size="25"
              class="mr-2"
            ></v-progress-circular>
            Loading...</v-btn
          >
        </div>
      </v-card>
      <div class="pa-2">
        <minat-kepribadian-modal :dialog="dialog" @close="dialog = false" />
      </div>
    </div>
    <div class="right_">
      <img
        src="../../assets/img/Asset cowok cewek (full badan).svg"
        class="illustrate"
        alt="minat kepribadian teman bakat"
      />
    </div>
  </div>
</template>

<script>
import minatKepribadianModal from "./minatKepribadianModal.vue";
export default {
  components: { minatKepribadianModal },
  name: "minatKepribadianPage",
  data() {
    return {
      dialog: false,
      loading: false,
      // isDiable: false,
      form: {
        nama: "",
        email: "",
        no_hp: "",
        nama_sekolah: "",
      },
      err: {
        nama: "",
        email: "",
        no_hp: "",
        nama_sekolah: "",
      },
    };
  },
  methods: {
    postData() {
      for (let key in this.form) {
        this.err[key] = "";
      }
      let data = {
        path: "minat-kepribadian/store",
        body: this.form,
      };
      this.loading = true;
      this.$store
        .dispatch("postApi", data)
        .then(() => {
          this.dialog = true;
          this.loading = false;
          for (let key in this.form) {
            this.form[key] = "";
          }
        })
        .catch((err) => {
          console.log(err);
          let required = err.response.data.data.errors;
          if (required) {
            for (let key in required) {
              this.err[key] = required[key][0];
            }
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.container_minat {
  min-height: 100vh;
  width: 100%;
  background: #3c033d;
  display: flex;
  align-items: center;
}
.left_ {
  width: 500px;
  padding-left: 100px;
}
.right_ {
  flex: 1;
  padding-right: 100px;
  display: flex;
  justify-content: center;
}
.form_card {
  background: #c4b3c5 !important;
  border-radius: 30px !important;
}
.input_minat {
  background: #edebeb !important;
  padding: 10px;
  border-radius: 10px;
  width: 100%;
}
.input_minat:focus {
  outline: #3c033d;
}
.flexy {
  flex: 1;
}
.illustrate {
  height: 500px;
}
@media (max-width: 992px) {
  .illustrate {
    height: 400px;
  }
  .right_ {
    justify-content: end;
  }
}
@media (max-width: 850px) {
  .left_ {
    padding-left: 50px;
  }
  .right_ {
    padding-right: 50px;
  }
}
@media (max-width: 700px) {
  .right_ {
    padding-right: 0;
  }
  .left_ {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    min-height: 100vh;
    z-index: 2;
    width: 100%;
    padding: 20px;
  }
  .form_card {
    width: 80%;
  }
  .illustrate {
    height: 500px;
  }
}
@media (max-width: 500px) {
  .form_card {
    width: 90%;
  }
  .illustrate {
    height: 300px;
  }
}
</style>
